import { render, staticRenderFns } from "./categoriaproductoEdit.vue?vue&type=template&id=359bd5d2&"
import script from "./categoriaproductoEdit.vue?vue&type=script&lang=js&"
export * from "./categoriaproductoEdit.vue?vue&type=script&lang=js&"
import style0 from "./categoriaproductoEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports